import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import {
  AllScheduleConfigListReq,
  CreatePracticeConfigCommand,
  PmsConfigResponse,
  PracticeConfig,
  PracticeScheduleConfig,
  Response,
} from '../models';
@Injectable({
  providedIn: 'root',
})
export class PracticeConfigService {
  private api: string = CONTROLLERS.PRACTICE_CONFIG;
  constructor(private apiService: ApiService) { }

  createPracticeConfig(
    createPracticeConfigCommand: CreatePracticeConfigCommand
  ): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.CREATE_PRACTICE_CONFIG}`,
      createPracticeConfigCommand
    );
  }

  getPracticeConfigs(
    practiceId: number
  ): Observable<Response<PracticeConfig[]>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.GET_PRACTICE_CONFIGS}/${practiceId}`
    );
  }

  getScheduleConfig(
    practiceId: number
  ): Observable<Response<PracticeScheduleConfig>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.GET_SCHEDULE_CONFIG}/${practiceId}`
    );
  }

  getScheduleConfigById(
    id: number
  ): Observable<Response<PracticeScheduleConfig>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.GET_SCHEDULE_CONFIG_BY_ID}/${id}`
    );
  }

  getAllScheduleConfig(
    paginationRequestCommand: AllScheduleConfigListReq
  ): Observable<Response<PracticeScheduleConfig>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.GET_ALL_SCHEDULE_CONFIG_LIST}`,
      paginationRequestCommand
    );
  }
  getPmsConfig(): Observable<Response<PmsConfigResponse>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PRACTICE_CONFIG.GET_PMS_CONFIG}`
    );
  }
}
